// ── Dates, in the athlete's own time ─────────────────────────────────────────

const pad = (n: number) => String(n).padStart(2, '0')
export const localToday = () => {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
export const addDays = (date: string, n: number) => {
  const d = new Date(`${date}T12:00:00`)
  d.setDate(d.getDate() + n)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
export const mondayOf = (date: string) => {
  const day = new Date(`${date}T12:00:00`).getDay()
  return addDays(date, day === 0 ? -6 : 1 - day)
}
export const fmt = (date: string, opts: Intl.DateTimeFormatOptions) =>
  new Date(`${date}T12:00:00`).toLocaleDateString('en-US', opts)

export const PLATFORMS = [
  { id: 'instagram', label: 'Instagram' },
  { id: 'tiktok', label: 'TikTok' },
  { id: 'youtube', label: 'YouTube' },
] as const

export const fieldCls =
  'w-full rounded-xl border border-border bg-[#FFFFFF] px-3.5 py-2.5 text-base text-foreground placeholder:text-muted-foreground outline-none focus:border-[#84CC16] focus:ring-4 focus:ring-[#C0FD72]/40'

export type Draft = {
  plannedOn: string
  plannedTime: string
  platform: string
  theme: { id: string | null; label: string } | null
  idea: string
}

export const newDraft = (day: string, themes: { id: string; label: string }[]): Draft => ({
  plannedOn: day,
  plannedTime: '',
  platform: 'instagram',
  theme: themes[0] ? { id: themes[0].id, label: themes[0].label } : null,
  idea: '',
})
